"use client"
import React, { useEffect } from 'react'
import styles from './banner.module.scss'
import { usePathname } from 'next/navigation'
import { __DEV__ } from '@lib/helpers'

const SLOTS: { [key: string]: string } = {
    "1358349327": "0",
    "9619982722": "300_600",
}
const initAd = () => {
    try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
        console.error(err)
    }
}
interface IBanner {
    slot: string
    /** Route prefixes this instance should sit out. The layout-level unit uses
     *  it to stay off the category hubs, where it would otherwise take the whole
     *  first viewport on mobile before the player is even reachable — those
     *  pages carry their own unit below the station grid instead. */
    except?: string[]
}

export default function Banner({ slot, except }: IBanner) {
    const path = usePathname()
    
    useEffect(() => {
        initAd()
    }, [path])

    if (path.startsWith('/admin'))
        return null

    if (except?.some(prefix => path.startsWith(prefix)))
        return null
    
    return (
        <div className={`${styles.container} ${styles[`size${SLOTS[slot]}`]} ${__DEV__ && styles.dev}`}>
            <div key={path.replace(/\//g, "-") + "-" + slot + "-" + "default-ad-unit-type"}>
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client={process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID}
                data-ad-slot={slot}
                data-ad-format="auto"
                data-full-width-responsive="true" />
            </div>
        </div>
    )
}